import VDistpicker from 'v-distpicker';
import Vue from 'vue';
Vue.component('VDistpicker', VDistpicker);
